import { For } from 'solid-js';
import type { SellbotZoneDto } from '../api';
import { useTranslation } from '../hooks/useTranslation';
import { ZONE_FILTER_ALL, ZONE_FILTER_OUTSIDE } from '../hooks/useSellbotZones';

interface SellbotZoneFilterProps {
    zones: SellbotZoneDto[];
    value: string;
    onChange: (zoneFilter: string) => void;
}

export default function SellbotZoneFilter(props: SellbotZoneFilterProps) {
    const { t } = useTranslation();
    return (
        <select value={props.value} onChange={(e) => props.onChange(e.currentTarget.value)}>
            <option value={ZONE_FILTER_ALL}>{t('SELLBOT_ZONE_FILTER_ALL')}</option>
            <For each={props.zones}>{(zone) => <option value={zone.id}>{zone.name}</option>}</For>
            <option value={ZONE_FILTER_OUTSIDE}>{t('SELLBOT_ZONE_FILTER_OUTSIDE')}</option>
        </select>
    );
}
